<cdk-virtual-scroll-viewport class="tw-h-full tw-w-full [&_.cdk-virtual-scroll-content-wrapper]:tw-max-w-full"
                             [itemSize]="itemSize" [minBufferPx]="screenHeight" [maxBufferPx]="screenHeight">
    <div *cdkVirtualFor="let item of itemsSet; trackBy: trackByFunction; let last = last; let odd = odd"
         class="tw-pb-1" [ngClass]="last ? customClass || '' : ''">
        <app-showcase-list-item-v2
            [item]="item"
            [itemCategory]="categoriesById[item.category_id!]"
            [odd]="odd"
            [showThumbnail]="showThumbnail"
            [showUnavailableStock]="showUnavailableStock"
            [priceWithCurrency]="priceWithCurrency"
            [showPrices]="showPrices"
            [showItemIcon]="showItemIcon"
            [fontNameSize]="fontNameSize"
            [fontPriceSize]="fontPriceSize"
            [priceIdentifier]="priceIdentifier"
            [getStockStatus]="getStockStatus"
            (itemTapped)="itemTap($event)"
            (itemLongPressed)="itemPress($event)"
        />
    </div>
</cdk-virtual-scroll-viewport>
